var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain-select-width"},[_c('v-select',_vm._g(_vm._b({attrs:{"value":_vm.value,"items":_vm.items,"dense":"","outlined":"","hide-details":"","label":_vm.label}},'v-select',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }